import Vue from 'vue'
import axios from 'axios';
import router from './router';

var api = axios.create({
  //baseURL: process.env.NODE_ENV === 'production'? 'https://'+localStorage.getItem('server'): 'http://scout3.test'
});

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


api.interceptors.response.use((response) => {
    return response;
}, function (error) {
    // Do something with response error
    if (error.response && error.response.status === 401) {
        localStorage.removeItem('user');
        notie.alert({ type: 'error', text: _t('jint-user-loggedoff') });
        router.replace('/');
        return response;
    } else {
      return Promise.reject(error.response || error);
    }
});


api.interceptors.request.use(function(request) {
  /*const token = localStorage.getItem("token");
  if ( token != null ) {
    request.headers.Authorization = `Bearer ${token}`;
  }*/
  return request;
}, function(err) {
  return Promise.reject(err);
});

api.interceptors.request.use( request => {
  /*const token = localStorage.getItem("token");
  if ( token != null ) {
    request.headers.Authorization = `Bearer ${token}`;
  }*/
  return request;
}, error => Promise.reject(error));


Vue.prototype.$api = api;

export default api;
